/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "use-vue-service";

@Injectable()
export class LoggerService {
  log(...msg: any[]) {
    console.log("msg :>> ", ...msg);
  }
  info(...msg: any[]) {
    console.info("msg :>> ", ...msg);
  }
  error(...msg: any[]) {
    console.error("msg :>> ", ...msg);
  }
}
